import { createContext, useContext } from 'react';
import { hasAtLeast, keys } from 'remeda';

import { getCharacterCount } from '@@utils/charactersCount';

type Add = ({ id, count }: { id: Id; count: number }) => VoidFunction;

type State = Record<string, number>;

type CharacterCountContextType = {
    state: State;
    add: Add;
};

const CharacterCountContext = createContext<CharacterCountContextType | null>(null);

export const useTotalCharacterCount = (value) => {
    const context = useContext(CharacterCountContext);

    if (context && hasAtLeast(keys(context.state), 1)) {
        return Object.values(context.state).reduce((accumulator, count) => accumulator + count, 0);
    }

    return getCharacterCount(value);
};
